export const menuHospital = [
  {
    id: 1,
    label: "管理メニュー",
    isTitle: true,
  },
  {
    id: 10,
    label: "患者一覧",
    icon: "",
    link: "/hospital/patients",
  },
];

export const menuAdmin = [
  {
    id: 1,
    label: "管理メニュー",
    isTitle: true,
  },

  {
    id: 10,
    label: "1.会員一覧",
    icon: "",
    link: "/admin/customers",
  },

  {
    id: 13,
    label: "2.施設一覧 (登録)",
    icon: "",
    link: "/admin/facilities",
  },

  {
    id: 11,
    label: "3.アカウント一覧 (登録)",
    icon: "",
    link: "/admin/operators",
  },


  {
    id: 12,
    label: "4.関節モーニング動画",
    icon: "",
    link: "/admin/videos",
  },
  {
    id: 18,
    label: "5.通知",
    icon: "",
    link: "/admin/notifications",
  },

];
